export default __webpack_public_path__ + "static/media/sec_capacitacion.f0733fdf.png";